<template>
    <div class="main-box mh-a softwarePage">
        <!-- <iristar-dividing>{{ $t("software.title") }}</iristar-dividing> -->
        <div class="h140px ovh lh140 fs30 c-white text-center solution-title"
            :style="`background-image: url(/static/img/solution/s2.jpg);`">
            {{ $t("software.title") }}
        </div>
        <div class="p30  detailContent" style="" v-for="(item, index) in software" :key="`${index}_software`">
            <p :id="item.id" style="height: 0;position: relative;top: -60px;"></p>
            <div class="software-title text-center fs32" style="padding-bottom: 20px; font-size: 24px;">
                {{ item.title }}
            </div>
            <div class="software-subtitle">
                {{
                item.desc }}</div>

            <div v-for="(soft, dx) in item.introduce" :key="`${dx}_intr`" :class="soft.class"
                style="margin-top:15px ;margin-bottom: 3em;" class="soft-item">
                <div class="detail-img" v-if="item.img[dx]">
                    <img :src="'/static/img/programme/' + item.img[dx]" alt="" class="img-zoom"
                        @click="openPreview(item, dx)">
                </div>
                <div style="flex:1" class="softdetail">
                    <p class=" lh30 fs14  soft-text" :class="soft.class + dx" v-if="soft.type === 'html'"
                        v-html="soft.inner">
                    </p>
                    <p class=" lh30 ext-indent  text-indent fs14  soft-text" v-else-if="soft.type === 'subtitle'"
                        v-html="soft.inner">
                    </p>

                    <p class="text-indent lh30 fs14  soft-text" v-else-if="soft.type === 'text'">{{ soft.inner }}</p>
                </div>

            </div>
        </div>

        <!-- 图片放大查看 -->
        <div class="img-viewer" v-if="previewSrc" @click="closePreview">
            <img :src="previewSrc" alt="" @click.stop>
            <span class="img-viewer-close" @click="closePreview">&times;</span>
        </div>
    </div>
</template>

<script>
// import IristarDividing from "@/components/IristarDividing";
import SoftwareList from "@/assets/software/software";
import SoftwareListEn from "@/assets/software/software-en";
export default {
    // components: { IristarDividing },
    name: "IristarSoftware",
    data() {
        return {
            previewSrc: "",
        };
    },
    computed: {
        software() {
            return this.$store.state.language === "zh"
                ? SoftwareList
                : SoftwareListEn;
        },
    },
    methods: {
        openPreview(item, dx) {
            if (!item.img[dx]) return;
            this.previewSrc = "/static/img/programme/" + item.img[dx];
        },
        closePreview() {
            this.previewSrc = "";
        },
        onKeydown(e) {
            if (e.key === "Escape") this.closePreview();
        },
    },
    watch: {
        '$route.query.anchor'(anchorval) {
            var anchor = document.getElementById(anchorval);
            anchor.scrollIntoView({
                // behavior: "smooth",  // 平滑过渡
                block: "start"  // 上边框与视窗顶部平齐。默认值
            });




        }
    },
    mounted() {
        window.addEventListener("keydown", this.onKeydown);
        if (this.$route.query && this.$route.query.anchor) {
            var anchor = document.getElementById(this.$route.query.anchor);
            this.$nextTick(() => {
                setTimeout(() => {
                    anchor.scrollIntoView({
                        // behavior: "smooth",  // 平滑过渡
                        block: "start"  // 上边框与视窗顶部平齐。默认值
                    });
                }, 600)
            })

        }
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.onKeydown);
    }
};
</script>

<style lang="less">
.software-title {
    // border-left: 5px solid rgba(#14284b, 0.8);
    // text-indent: 8px;
    font-size: 20px;
    font-weight: 600;

    margin-bottom: 12px;
}



.software-subtitle {

    line-height: 230%;
    font-size: 18px;
    text-indent: 2em;
    margin-bottom: 26px;

    margin: 15px 0;
}

.softwarePage .detail-img {
    // width: 90%;
    padding: 10px;
    text-align: center;
}

.softwarePage .soft-item {
    padding: 0 20px;

}

.softwarePage .softdetail {
    width: 100%;
    // flex: none;
}

.softdetail p {
    font-size: 15px;
    margin-bottom: 0.6em;
}

@media (min-width: 768px) {
    .software-subtitle {
        padding-right: 220px;
        padding-left: 30px;
        font-size: 16px;
    }

    .softwarePage .soft-item {
        padding: 0 60px;
        display: flex;
    }

    .softwarePage .detail-img {
        width: 400px;
        padding: 30px 50px;
    }

    .softdetail .soft-text {
        padding-right: 220px;
    }

    .softdetail p {
        font-size: 16px;
        margin-bottom: 1em;
    }

}



.detailContent p {
    // line-height: 300%;
}



.detailContent .tit {
    font-size: 18px;
    margin-bottom: 0;
    font-weight: 600;
}

.d-a2 .soft-text {
    padding-top: 30px;
}

.d-c10 {
    margin-top: 40px;
}

.d-c21 {
    margin-top: 40px;
}

.d-d10 {
    margin-top: 30px;
}

.d-e10 {
    margin-top: 40px;
}

.d-e2 {
    margin-top: 40px;
}

.d-e21 {
    margin-top: 40px;
}

.d-e32 {
    margin-top: 40px;
}

/* 开源信息搜集处理系统：小标题与正文间距 */
.softwarePage .d-f1 .tit,
.softwarePage .d-f2 .tit,
.softwarePage .d-f3 .tit {
    margin-bottom: 14px;
}

/* 产品资料区块底部留白 */
.softwarePage .d-f3 {
    margin-bottom: 60px;
}

/* 产品资料下载卡片 */
.softwarePage .doc-card {
    display: flex;
    align-items: center;
    gap: 18px;
    max-width: 560px;
    padding: 18px 24px;
    border: 1px solid #e4e7ed;
    border-radius: 10px;
    background: linear-gradient(180deg, #fbfcfe 0%, #f5f7fa 100%);
    transition: box-shadow .25s ease, transform .25s ease;
}

.softwarePage .doc-card:hover {
    box-shadow: 0 6px 18px rgba(20, 40, 75, 0.12);
    transform: translateY(-2px);
}

.softwarePage .doc-card-icon {
    flex: none;
    line-height: 0;
}

.softwarePage .doc-card-info {
    flex: 1;
    min-width: 0;
}

.softwarePage .doc-card-info p {
    padding-right: 0;
}

.softwarePage .doc-card-name {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    word-break: break-all;
}

.softwarePage .doc-card-meta {
    margin: 6px 0 0;
    font-size: 12px;
    color: #909399;
}

.softwarePage .doc-card-btn {
    flex: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 9px 20px;
    border-radius: 20px;
    background: #1a5fb4;
    color: #fff;
    font-size: 14px;
    text-decoration: none;
    transition: background .25s ease;
}

.softwarePage .doc-card-btn:hover {
    background: #144d96;
    color: #fff;
}

@media (max-width: 768px) {
    .softwarePage .doc-card {
        flex-wrap: wrap;
    }

    .softwarePage .doc-card-btn {
        width: 100%;
        justify-content: center;
    }
}

/* 图片点击放大 */
.softwarePage .img-zoom {
    cursor: zoom-in;
    transition: box-shadow .25s ease;
}

.softwarePage .img-zoom:hover {
    box-shadow: 0 4px 16px rgba(20, 40, 75, 0.18);
}

.softwarePage .img-viewer {
    position: fixed;
    inset: 0;
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.75);
    cursor: zoom-out;
}

.softwarePage .img-viewer img {
    max-width: 92%;
    max-height: 88vh;
    border-radius: 4px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
    cursor: default;
}

.softwarePage .img-viewer-close {
    position: absolute;
    top: 20px;
    right: 32px;
    font-size: 40px;
    line-height: 1;
    color: rgba(255, 255, 255, 0.85);
    cursor: pointer;
    user-select: none;
}

.softwarePage .img-viewer-close:hover {
    color: #fff;
}
</style>